import APIClient from '@/shared/http/clients/api'

const resourceName = 'QuadroFuncionario'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (companyID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}`, data, config)
const GetAllPaging = (companyID, limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const Search = (companyID, data = {}, limit, index, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/search/${companyID}?limit=${limit}&index=${index}`, data, config)
const Print = (data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/print`, data, config)
const Clone = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/clone/${id}`, config)

const EmployeeBoardRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  Print,
  Clone
}

export default EmployeeBoardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/employeeboard.js